import { useState, useEffect } from 'react';

export function useAsync(fn, deps=[]) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let canceled = false;
    setLoading(true); setError(null);
    fn()
      .then(res => !canceled && setData(res))
      .catch(err => !canceled && setError(err))
      .finally(() => !canceled && setLoading(false));
    return () => void (canceled = true);
  }, deps);

  return { data, loading, error };
}
